/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  var popup = document.querySelector('.NewsletterPopup');

  if (!popup) {
    return;
  }

  function markLocation(locationName) {
    var buttons = popup.querySelectorAll('[data-action="select-location"]');

    for (var i = 0; i < buttons.length; i++) {
      var isSelected = buttons[i].getAttribute('data-location') === locationName;
      buttons[i].classList.toggle('is-selected', isSelected);
      buttons[i].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
  }

  popup.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="select-location"]');

    if (!button) {
      return;
    }

    var locationName = button.getAttribute('data-location');

    try {
      localStorage.setItem('themePopupLocation', locationName);
    } catch (error) {
      // Some browsers throw when local storage is unavailable
    }

    markLocation(locationName);

    setTimeout(function () {
      popup.setAttribute('aria-hidden', 'true');
      try {
        sessionStorage.setItem('themePopup', 'true');
      } catch (error) {
        // Ignore storage access errors
      }
    }, 300);
  });

  try {
    var savedLocation = localStorage.getItem('themePopupLocation');

    if (savedLocation) {
      markLocation(savedLocation);
    }
  } catch (error) {
    // Ignore storage access errors
  }
})();
